import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Channel } from '@pixacare/chat';
import { PublicUser } from '@pixacare/domain';
import { CrossBadgeComponent } from 'src/app/shared/components/cross-badge/cross-badge.component';
import { UserCardComponent } from 'src/app/shared/components/user-card/user-card.component';
import { ChannelPreviewComponent } from '../channel-preview/channel-preview.component';

@Component({
  selector: 'pxc-receiver-list',
  imports: [UserCardComponent, ChannelPreviewComponent, CrossBadgeComponent],
  templateUrl: './receiver-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReceiverListComponent {
  @Input() removable = true;
  @Input() channels: Channel[];
  @Input() users: PublicUser[];
  @Input() mailAddresses: string[];
  @Output() removeChannel = new EventEmitter<Channel>();
  @Output() removeUser = new EventEmitter<PublicUser>();
  @Output() removeMailAddress = new EventEmitter<string>();
}
